import { useState, useEffect } from "react";
import SmHeader from "../../components/ForPages/SmHeader";
import HomeHeader from "../../components/ForPages/HomeHeader";
import { Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { getForm } from "../../actions/forms";
import { useDispatch } from "react-redux";
import Design from "../../components/ForPages/Design";
import Footer from "../../components/ForPages/Footer";
import PaymentPopup from "../../components/PaymentPopup";
import "./Home.css";
import "./Responsive.css";
import { useHistory } from "react-router-dom";
import CreativeCreateDesignForm from "../../components/userForms/CreativeCreateDesignForm";

const CreativeChooseYourDesign = () => {
  document.body.style.backgroundColor = "#E5E4EF";
  const [showCreateDesignForm, setShowCreateDesignForm] = useState(false);
  const dispatch = useDispatch(),
    [monthDownloadNbr, setMonthDownloadNumber] = useState(257),
    [totalDownloadNumber, setTotalDownloadNumber] = useState(500),
    [PaymentPopupDisplay, setPaymentPopupDisplay] = useState("none");
  const userToken = localStorage?.getItem("skiUserToken");
  const [designs, setDesigns] = useState([
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
      {
        imgSrc: "/Images/groovinx.png",
        title: "Get Free Wine Now!",
        type: "Facebook Post",
      },
    ]),
    [userRole, setUserRole] = useState("creative"),
    history = useHistory();
  useEffect(() => {
    document.title = "Welcome to Ski Studio";
    if (userToken) {
      try {
        let decodedToken = jwt_decode(userToken);
        setUserRole(decodedToken.AccountType);
        if (decodedToken.AccountType !== "creative") history.push("/");
      } catch (err) {
        history.push("/");
      }
    } else {
      localStorage.removeItem("skiUserToken");
      setUserRole("");
      history.push("/");
    }
  }, [userToken, history]);
  return (
    <>
      {showCreateDesignForm && <CreativeCreateDesignForm />}
      <div className="Home ChooseYourDesign">
        {userRole !== "creative" && <Redirect to="/" />}
        <SmHeader />
        <HomeHeader
          tab="home"
          include=""
          showPaymentPopup={setPaymentPopupDisplay}
        />
        <div className="creative-designs-list mt-0">
          <div className="d-flex align-items-center justify-content-around">
            <button
              className="biz-btn btn text-white btn-sm px-3 py-2 shadow-sm"
              style={{ background: "black", marginLeft: "1em" }}
              onClick={() => history.push("/creative-home")}
            >
              Back
            </button>
            <h3
              className="text-center p-3"
              style={{ width: "60%", fontFamily: "Ubuntu" }}
            >
              Choose Your Design
            </h3>
            <button
              className="request-custom-design biz-btn btn text-white btn-sm px-3 py-2 shadow-sm"
              style={{ background: "#1D8CFB", fontFamily: "Ubuntu" }}
              // onClick={() => history.push("/creative-home")}
            >
              Request Custom Design
            </button>
          </div>
          <div>
            {designs.map((design, index) => (
              <Design key={index} design={design} />
            ))}
          </div>
        </div>
        <Footer />
        <PaymentPopup
          display={PaymentPopupDisplay}
          hidePopupDisplay={setPaymentPopupDisplay}
        />
      </div>
    </>
  );
};

export default CreativeChooseYourDesign;
